// extracted by mini-css-extract-plugin
export var cardblock = "style-module--cardblock--97c52";
export var colLeft = "style-module--colLeft--26b3b";
export var container = "style-module--container--541b9";
export var dropdownIcon = "style-module--dropdownIcon--0869a";
export var dropdownTxt = "style-module--dropdownTxt--f1a03";
export var leftblock = "style-module--leftblock--5df02";
export var navlinkText = "style-module--navlinkText--51b89";
export var outer = "style-module--outer--b99fd";
export var row = "style-module--row--e3592";
export var subItems = "style-module--subItems--f718f";
export var subitemLink = "style-module--subitemLink--29022";
export var subtitle = "style-module--subtitle--dbc28";
export var tagline = "style-module--tagline--a60e0";
export var textblock = "style-module--textblock--06165";
export var viewallBtn = "style-module--viewallBtn--80559";
export var wrap = "style-module--wrap--0c2c3";